<template>
  <div>
    <div class="mb-3 font-size-subtitle-1">
      <span>請選取欲申請的品牌（僅會顯示尚未產出網址的門市）。</span>
    </div>
    <div class="mb-3">
      <multiselect
        v-model="brand"
        :options="brands"
        :searchable="true"
        :allow-empty="true"
        :close-on-select="true"
        :placeholder="'== 品牌 =='"
        :show-labels="false"
        :multiple="false"
        label="label"
        track-by="value"
      />
    </div>
    <nd-trade-apply-store-multi-select-listbox
      :brandId="brandId"
      :getDataH="getDataH"
      :status="status"
      :storeId="storeId"
      :tradeType="tradeType"
      @update:choose="updateChoose"
    />
    <div
      class="mt-1 font-size-subtitle-2 text-right"
      v-text="`已選 ${ chose.length } 擇`"
    />
  </div>
</template>

<script>
import NdTradeApplyStoreMultiSelectListbox from '@/components/elements/nd-trade-apply-store-multi-select-listbox.vue'

export default {
  name: 'nd-trade-apply-store',
  props: {
    brands: {
      type: Array,
      default: []
    },
    getDataH: {
      type: Function
    },
    tradeType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      brand: {
        label: '== 品牌 ==',
        value: 0
      },
      chose: [],
      status: [1, 2],
      storeId: 0
    }
  },
  components: {
    'nd-trade-apply-store-multi-select-listbox': NdTradeApplyStoreMultiSelectListbox
  },
  computed: {
    brandId () {
      return this.brand.value
    }
  },
  methods: {
    updateChoose (val) {
      this.chose = val
      this.$emit('update:choose', {
        brand: this.brandId,
        store: this.chose
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-1 {
  margin-top: 4px;
}
.font-size-subtitle-2 {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// nd-trade-apply-store.vue?78bb200a